import { Box } from '@mui/material'
import PropTypes from 'prop-types'

const THEME_PRESETS = {
    white: {
        outline: '#D9E2EE',
        sidebar: '#111827',
        sidebarActive: '#10B981',
        sidebarMuted: '#4B5563',
        body: '#F3F7FD',
        topbar: '#FFFFFF',
        panel: '#FFFFFF',
        textPrimary: '#5B6472',
        textSecondary: '#A0AEC0',
        dot: '#A0AEC0'
    },
    pastel: {
        outline: '#D6E0EE',
        sidebar: '#111827',
        sidebarActive: '#10B981',
        sidebarMuted: '#4B5563',
        body: '#EAF1FF',
        topbar: '#F5F8FF',
        panel: '#FFFFFF',
        textPrimary: '#6C7687',
        textSecondary: '#A7B0BF',
        dot: '#A7B0BF'
    },
    grey: {
        outline: '#41516D',
        sidebar: '#1A202C',
        sidebarActive: '#10B981',
        sidebarMuted: '#4B5563',
        body: '#30363D',
        topbar: '#394251',
        panel: '#3C4757',
        textPrimary: '#BAC6D9',
        textSecondary: '#8C9BB2',
        dot: '#A0AEC0'
    },
    dark: {
        outline: '#3D4E69',
        sidebar: '#1A202C',
        sidebarActive: '#10B981',
        sidebarMuted: '#4B5563',
        body: '#1F2433',
        topbar: '#293143',
        panel: '#313C4F',
        textPrimary: '#C1CDE1',
        textSecondary: '#8797B0',
        dot: '#A0AEC0'
    },
    black: {
        outline: '#303641',
        sidebar: '#12161F',
        sidebarActive: '#10B981',
        sidebarMuted: '#394153',
        body: '#000000',
        topbar: '#0D1118',
        panel: '#171B24',
        textPrimary: '#C8D1E0',
        textSecondary: '#808EA5',
        dot: '#A0AEC0'
    },
    'black-experimental': {
        outline: '#3E5375',
        sidebar: '#0A0D14',
        sidebarActive: '#4D7DFF',
        sidebarMuted: '#2B354A',
        body: '#05060A',
        topbar: '#0F1420',
        panel: '#171F2F',
        textPrimary: '#D4DEEF',
        textSecondary: '#8FA0BF',
        dot: '#B5C0D6'
    }
}

const SIDEBAR_ROWS = [0, 1, 2, 3]

const ThemePreviewIcon = ({ value }) => {
    const palette = THEME_PRESETS[value] || THEME_PRESETS.white

    return (
        <Box
            sx={{
                aspectRatio: '152 / 130',
                border: '1px solid',
                borderColor: palette.outline,
                display: 'flex',
                overflow: 'hidden',
                width: '100%'
            }}
        >
            <Box
                sx={{
                    backgroundColor: palette.sidebar,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0.5,
                    px: 0.75,
                    py: 0.9,
                    width: '34%'
                }}
            >
                <Box
                    sx={{
                        backgroundColor: palette.sidebarActive,
                        borderRadius: 999,
                        height: 5,
                        width: '78%'
                    }}
                />
                {SIDEBAR_ROWS.map((row) => (
                    <Box
                        key={row}
                        sx={{
                            backgroundColor: palette.sidebarMuted,
                            borderRadius: 999,
                            height: 5,
                            width: '100%'
                        }}
                    />
                ))}
            </Box>
            <Box
                sx={{
                    backgroundColor: palette.body,
                    display: 'flex',
                    flexDirection: 'column',
                    width: '66%'
                }}
            >
                <Box
                    sx={{
                        alignItems: 'center',
                        backgroundColor: palette.topbar,
                        display: 'flex',
                        height: '17%',
                        justifyContent: 'space-between',
                        px: 0.65
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: palette.textSecondary,
                            borderRadius: 999,
                            height: 4,
                            width: '43%'
                        }}
                    />
                    <Box sx={{ display: 'flex', gap: 0.4 }}>
                        <Box
                            sx={{
                                backgroundColor: palette.dot,
                                borderRadius: '50%',
                                height: 4,
                                width: 4
                            }}
                        />
                        <Box
                            sx={{
                                backgroundColor: palette.dot,
                                borderRadius: '50%',
                                height: 4,
                                width: 4
                            }}
                        />
                    </Box>
                </Box>
                <Box sx={{ display: 'grid', gap: 0.55, p: 0.75 }}>
                    <Box
                        sx={{
                            backgroundColor: palette.panel,
                            borderRadius: 0.75,
                            height: 14
                        }}
                    />
                    <Box
                        sx={{
                            backgroundColor: palette.textPrimary,
                            borderRadius: 999,
                            height: 4,
                            width: '76%'
                        }}
                    />
                    <Box
                        sx={{
                            backgroundColor: palette.textSecondary,
                            borderRadius: 999,
                            height: 4,
                            width: '58%'
                        }}
                    />
                </Box>
            </Box>
        </Box>
    )
}

ThemePreviewIcon.propTypes = {
    value: PropTypes.string.isRequired
}

export default ThemePreviewIcon
